// extracted by mini-css-extract-plugin
module.exports = {"card":"card-j1CET","callout":"callout-sKK0n"};